<template>
  <div style="background: #4953cf;">
    <div class="header-content">
      <div>
        <span>充值记录</span>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <span class="dorm-text">{{dormName}}</span>
      </div>
      <div class="dorm-mesage">{{userName}}</div>
      <!-- <div style="text-align: center;margin-top: 40px;">
        <button style="border-radius: 20px 0px 0px 20px;" class="recharge-btn" v-bind:class="{ active : type == '充值完成'}" @click="() => chooice('充值完成')">充值完成</button>
        <button style="border-radius: 0px 20px 20px 0px;" class="recharge-btn" v-bind:class="{ active : type == '充值中'}" @click="() => chooice('充值中')">充值中</button>
      </div> -->
    </div>
    <div class="fee-content">
      <div v-if="!list || list.length == 0" style="text-align: center;font-weight: 700;padding-top: 100px;">
        无充值记录
      </div>
      <div v-if="list && list.length">
        <div v-for="item in list" v-bind:key="item.id" class="weui-media-box weui-media-box_text weight">
          <h4 class="weui-media-box__title">{{item.payTime}}</h4>
          <p style="float: right" class="weui-media-box__desc">{{item.finished?'充值完成':'充值中'}}</p>
          <p class="weui-media-box__desc">充值金额: {{item.amount/100}}￥</p>
        </div>
      </div>
      <div style="text-align: center;">
        <button style="margin-top: 30px" class="recharge-btn" @click="loadMore">加载更多</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import weui from 'weui.js'
export default {
  name: 'container',
  data() {
    return {
      type: '充值完成'
    }
  },
  computed: mapState({
    dormName: state => state.user.currentUser.loudong + state.user.currentUser.room,
    userName: state => state.user.currentUser.name,
    payedHistory: state => state.trade.payedHistory,
    list: state => state.trade.list
  }),
  created() {
    this.$store.commit({type: 'trade/clearHistory'})
    this.$store.dispatch({type: 'trade/getHistoryPayed', data: {page: 1}})
  },
  methods: {
    loadMore() {
      if(this.payedHistory && this.payedHistory.pageNum < this.payedHistory.pages){
        this.$store.dispatch({type: 'trade/getHistoryPayed', data: {page: this.payedHistory.pageNum + 1}})
      }else{
        weui.alert("无更多记录", {
          className: "fm-border"
        })
        return;
      }
    }
  }
}
</script>

<style scoped>
  .header-content{
    background: #4953cf;
    min-height: 130px;
    color: white;
    padding: 30px;
  }
  .header-content span{
    font-weight: 600;
  }
  .dorm-text{
    font-size: 30px;
  }
  .dorm-mesage{
    text-align: center;
    font-size: 16px;
    margin-top: 20px;
    font-weight: 600;
  }
  .project{
    margin-top: 30px;
    background: white;
    color: #000;
    border-radius: 20px;
    text-align: center;
  }
  .project-main-text{
    color: #4b52aa;
    font-size: 18px;
    font-weight: 500;
    height: 70px;
    line-height: 70px;
  }
  .fee-content{
    border-radius: 20px 20px 0px 0px;
    background: white;
  }
  .fee-content-1{
    padding: 40px 20px 20px 20px;
  }
  .recharge-btn{
    height: 40px;
    width: 50%;
    background: white;
    color: #363fa3;
    font-weight: 500;
    font-size: 18px;
    border: 0px;
  }
  .active{
    background: #f1f1f1;
  }
  .weight{
    font-weight: 700;
  }
  .weight h4{
    font-weight: 700;
  }
</style>